module.exports = __webpack_public_path__ + "static/lightblue-rectangle-1ce3b0c6dd80fefee6513d0a7c745cd2.svg";